    import React, {useContext, useMemo, useState} from "react";
    import { useForm } from "react-hook-form";
    import { userAPI } from "../Redux/services/UserService";
    import { fileAPI } from "../Redux/services/FileService";
    import ReceiversList from "../domain/Files/recievers";
    import axios from "axios";
    import {AuthContext} from "../Infrastructure/provider/AuthProvider";
    import {queries} from "../Infrastructure/const/queries";
    
    export default function PersonalAccountPage() {
        const [selectedMenu, setSelectedMenu] = useState("received");
        const { register, handleSubmit, reset, watch, setValue, formState: {errors} } = useForm({});
        const { data: users } = userAPI.useFetchUsersQuery("");
        const { data: sentFiles, refetch:refetchSentFiles } = fileAPI.useFetchSentFilesQuery("");
        const { data: receivedFilesData, refetch:refetchReceivedFiles } = fileAPI.useFetchReceivedFilesQuery("");
        const {user: currentUser} = useContext(AuthContext);
        const otherUsers = users?.filter((u:any) => u.id !== currentUser.id) || [];
    
        const downloadFile = async (id: number, filename: string) => {
            try {
                const res = await axios.get(`${queries.baseURL}files/download/${id}`, {
                    responseType: 'blob',
                    headers: { Authorization: `Bearer ${localStorage.getItem("userToken")}` }
                });
    
                const url = window.URL.createObjectURL(res.data);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);

    
            } catch (error: any) {
                console.error('Ошибка скачивания файла:', error);
            }
            refetchSentFiles()
            refetchReceivedFiles()
        };
    
        const [query, setQuery] = useState("");
        const filteredUsers = useMemo(
            () =>
                otherUsers.filter((u: any) =>
                    u.full_name.toLowerCase().includes(query.trim().toLowerCase())
                ) ?? [],
            [otherUsers, query]
        );
    
        const watchedUsers = watch("users") || [];
    
        const onSubmit = async (data: any) => {
            if (!data.files || data.files.length === 0 || !data.users || data.users.length === 0) {
                alert("Немае користувача або файлiв");
                return;
            }
    
            const formData = new FormData();
            const files = data.files as FileList;
            Array.from(files).forEach((file) => formData.append("files[]", file));
            data.users.forEach((id: any) => formData.append("receivers[]", id));
            if (data.message) formData.append("message", data.message);
    
            try {
                const res = await fetch(`${queries.baseURL}files/upload`, {
                    method: "POST",
                    headers: { Authorization: `Bearer ${localStorage.getItem("userToken")}` },
                    body: formData,
                });
                if (!res.ok) throw new Error("Ошибка загрузки файла");
                const result = await res.json();
                console.log("Загружено:", result.files);
                alert("Файли успiшно завантажено");
                reset();
                setQuery("");
                refetchSentFiles()
                refetchReceivedFiles()
            } catch (err: any) {
                console.error(err);
                alert(err.message || "Помилка при відправленні файлу");
            }
        };

        const toggleSelectAll = () => {
            if (!otherUsers?.length) return;
            if (watchedUsers.length === otherUsers.length) setValue("users", []);
            else setValue("users", otherUsers.map((u: any) => u.id));
        };
    
        return (
            <div className="flex h-full w-full gap-4 p-4">
                {/* Left Menu */}
                <div className="w-64 rounded-2xl bg-white p-4 shadow-xl">
                    {/* Блок ФАЙЛИ */}
                    <h2 className="mb-4 text-xl font-semibold">Файли</h2>

                    <ul className="space-y-2 text-base mb-6">
                        {["received", "sent", "send"].map((menu) => (
                            <li key={menu}>
                                <button
                                    onClick={() => setSelectedMenu(menu)}
                                    className={`w-full rounded-xl p-2 text-left transition hover:bg-gray-100 ${
                                        selectedMenu === menu ? "bg-gray-100 font-medium" : ""
                                    }`}
                                >
                                    {menu === "received" && "Отриманi файли"}
                                    {menu === "sent" && "Вiдправленi файли"}
                                    {menu === "send" && "Вiдправити файли"}
                                </button>
                            </li>
                        ))}
                    </ul>

                    {/* Блок НАЛАШТУВАННЯ */}
                    <h2 className="mb-4 text-xl font-semibold">Налаштування</h2>

                    <ul className="space-y-2 text-base">
                        <li>
                            <button
                                onClick={() => setSelectedMenu("settings")}
                                className={`w-full rounded-xl p-2 text-left transition hover:bg-gray-100 ${
                                    selectedMenu === "settings" ? "bg-gray-100 font-medium" : ""
                                }`}
                            >
                                Змiна пароля
                            </button>
                        </li>
                    </ul>
                </div>
    
                {/* Right Content */}
                <div className="flex-1 rounded-2xl bg-white p-6 shadow-xl">
                    {selectedMenu === "received" && (
                        <div className={'h-[75vh] overflow-y-auto'}>
                            <h2 className="mb-4 text-xl font-semibold">Отриманi файли</h2>
                            {!receivedFilesData || receivedFilesData.length === 0 ? (
                                <div className="text-gray-500">Ви ще не отримали файли</div>
                            ) : (
                                <div className="overflow-x-auto">
                                    <table className="w-full border-collapse text-sm">
                                        <thead>
                                        <tr className="bg-gray-100 text-left">
                                            <th className="p-2 border-b">Файл</th>
                                            <th className="p-2 border-b">Вiд кого</th>
                                            <th className="p-2 border-b">Дата</th>
                                            <th className="p-2 border-b text-center">Дії</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {receivedFilesData && receivedFilesData?.map((file: any) => (
                                            <tr key={file.id} className="hover:bg-gray-50">
                                                <td className="p-2 border-b font-medium">{file.filename}</td>
                                                <td className="p-2 border-b">{file.sender}</td>
                                                <td className="p-2 border-b text-gray-600">
                                                    {new Date(file.created_at).toLocaleDateString("ru-RU")}
                                                </td>
                                                <td className="p-2 border-b text-center">
                                                    <button
                                                        onClick={() => downloadFile(file.id, file.filename)}
                                                        className="rounded-lg bg-blue-600 px-3 py-1 text-white text-xs hover:bg-blue-700"
                                                    >
                                                        Скачати
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    )}

                    {selectedMenu === "settings" && (
                        <div className="max-w-sm space-y-4">
                            <h2 className="mb-4 text-xl font-semibold">Змiна пароля</h2>

                            <form
                                onSubmit={handleSubmit(async (data) => {
                                    try {
                                        const res = await fetch(`${queries.baseURL}auth/change-password`, {
                                            method: "POST",
                                            headers: {
                                                "Content-Type": "application/json",
                                                Authorization: `Bearer ${localStorage.getItem("userToken")}`,
                                            },
                                            body: JSON.stringify({
                                                current_password: data.current_password,
                                                new_password: data.new_password,
                                            }),
                                        });

                                        if (!res.ok) {
                                            const err = await res.json();
                                            alert(err.error || "Помилка зміни пароля");
                                            return;
                                        }

                                        alert("Пароль успішно змінено");
                                        reset();
                                    } catch (e) {
                                        alert("Помилка сервера");
                                    }
                                })}
                                className="space-y-4"
                            >
                                <div>
                                    <label className="block text-sm font-medium">Поточний пароль</label>
                                    <input
                                        type="password"
                                        {...register("current_password")}
                                        className="mt-1 w-full rounded-xl border p-2"
                                        required
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium">Новий пароль</label>
                                    <input
                                        type="password"
                                        {...register("new_password" ,{
                                                required: "Пароль обов'язковий",
                                                minLength: {
                                                    value: 8,
                                                    message: "Пароль має містити мінімум 8 символів"
                                                },
                                                pattern: {
                                                    value: /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).+$/,
                                                    message: "Пароль має містити хоча б одну велику літеру та один спецсимвол"
                                                }
                                            }
                                        )}
                                        className="mt-1 w-full rounded-xl border p-2"
                                        required
                                    />

                                    {errors.new_password && (
                                        <p className="text-red-500 text-xs  mt-1">
                                            {errors.new_password.message as string}
                                        </p>
                                    )}
                                </div>

                                <button
                                    type="submit"
                                    className="rounded-xl bg-blue-600 p-2 text-white hover:bg-blue-700"
                                >
                                    Змінити пароль
                                </button>
                            </form>
                        </div>
                    )}

                    {selectedMenu === "sent" && (
                        <div className={'h-[75vh] overflow-y-auto'}>
                            <h2 className="mb-4 text-xl font-semibold">Вiдправленi файли</h2>
                            {!sentFiles || sentFiles.length === 0 ? (
                                <div className="text-gray-500">Ви ще не вiдправляли файли</div>
                            ) : (
                                <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
                                    <table className="w-full border-collapse text-sm">
                                        <thead>
                                        <tr className="bg-gray-100 text-left text-gray-700">
                                            <th className="p-3 border-b">Файл</th>
                                            <th className="p-3 border-b">Отримувачі</th>
                                            <th className="p-3 border-b">Дата</th>
                                            <th className="p-3 border-b text-center">Дії</th>
                                        </tr>
                                        </thead>
    
                                        <tbody>
                                        {sentFiles && sentFiles.map((file: any) => (
                                            <tr
                                                key={file.id}
                                                className="hover:bg-gray-50 transition-colors duration-150"
                                            >
                                                {/* Название файла */}
                                                <td className="p-3 border-b font-medium text-gray-800">
                                                    {file.filename}
                                                </td>
    
                                                {/* Список получателей */}
                                                <td className="p-3 border-b">
                                                    <div className="flex flex-wrap gap-2">
                                                        {file.receivers.map((r: any) => (
                                                            <div
                                                                key={r.id}
                                                                className={`flex items-center gap-1 rounded-full px-3 py-1 border ${
                                                                    r.downloaded
                                                                        ? "border-green-400 bg-green-50 text-green-700"
                                                                        : "border-gray-300 bg-gray-100 text-gray-600"
                                                                }`}
                                                            >
                                                                <span className="text-sm font-medium">{r.full_name}</span>
                                                                {r.downloaded ? (
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        className="h-4 w-4 text-green-500"
                                                                        fill="none"
                                                                        viewBox="0 0 24 24"
                                                                        stroke="currentColor"
                                                                        strokeWidth={2}
                                                                    >
                                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                                                    </svg>
                                                                ) : (
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        className="h-4 w-4 text-gray-400"
                                                                        fill="none"
                                                                        viewBox="0 0 24 24"
                                                                        stroke="currentColor"
                                                                        strokeWidth={2}
                                                                    >
                                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                                                    </svg>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>
    
                                                {/* Дата */}
                                                <td className="p-3 border-b text-gray-600 whitespace-nowrap">
                                                    {new Date(file.created_at).toLocaleDateString("uk-UA")}
                                                </td>
    
                                                {/* Кнопка скачать */}
                                                <td className="p-3 border-b text-center">
                                                    <button
                                                        onClick={() => downloadFile(file.id, file.filename)}
                                                        className="rounded-lg bg-blue-600 px-3 py-1 text-white text-xs font-medium hover:bg-blue-700 transition-colors"
                                                    >
                                                        Завантажити
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    )}
    
                    {selectedMenu === "send" && (
                        <form onSubmit={handleSubmit(onSubmit)} className="max-w-lg space-y-4">
                            {/* Users Select */}
                            <div>
                                <label className="mb-1 block text-sm font-medium">Оберiть користувачей</label>
                                <div className="rounded-xl border p-3">
                                    <input
                                        type="text"
                                        value={query}
                                        onChange={(e) => setQuery(e.target.value)}
                                        placeholder="Пошук користувача..."
                                        className="mb-2 w-full rounded-lg border p-2 text-sm"
                                    />
                                    <button
                                        type="button"
                                        onClick={toggleSelectAll}
                                        className="mb-2 rounded-lg bg-gray-200 px-3 py-1 text-sm hover:bg-gray-300"
                                    >
                                        {users && watchedUsers.length === users.length ? "Очистити" : "Вибрати всiх"}
                                    </button>
                                    <div className="mb-2 flex flex-wrap gap-2">
                                        {watchedUsers && Array.isArray(watchedUsers) ? (
                                            watchedUsers.map((id) => {
                                                const u = users.find((x: any) => x.id === Number(id));
                                                return (
                                                    <span key={id} className="rounded-full border px-3 py-1 text-sm">
                                                        {u ? u.full_name : id}
                                                    </span>
                                                );
                                            })
                                        ) : (
                                            <span className="text-sm text-gray-400">Нiкого не обрано</span>
                                        )}
                                    </div>
                                    <div className="max-h-40 space-y-1 overflow-y-auto pr-1 text-sm">
                                        {filteredUsers.length === 0 && (
                                            <div className="px-2 py-1 text-sm text-gray-500">Нiчого не знайдено</div>
                                        )}
                                        {filteredUsers.map((u: any) => (
                                            <label
                                                key={u.id}
                                                className="flex cursor-pointer items-center gap-2 rounded-lg p-1 hover:bg-gray-100"
                                            >
                                                <input type="checkbox" {...register("users")} value={u.id} />
                                                <span>{u.full_name}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </div>
    
                            {/* Files */}
                            <div>
                                <label className="mb-1 block text-sm font-medium">Виберiть файли</label>
                                <input
                                    type="file"
                                    multiple
                                    {...register("files")}
                                    className="w-full rounded-xl border p-2"
                                />
                            </div>
    
                            <button
                                type="submit"
                                className="rounded-xl bg-blue-600 p-2 text-white transition hover:bg-blue-700"
                            >
                                Вiдправити
                            </button>
                        </form>
                    )}
    
                    {selectedMenu === "all" && <div>Список всiх файлiв</div>}
                </div>
            </div>
        );
    }
